//angular imports
import {
    ChangeDetectionStrategy,
    Component, 
    WritableSignal, 
    signal,
} from '@angular/core';

//local imports
import { PresenterType } from '@shared/components';
import { ProjectNotFoundMessage } from './project-not-found.message';

@PresenterType(
{
    model: ProjectNotFoundMessage
})
@Component({
    selector: 'project-not-found-message-template',
    templateUrl: './project-not-found-message-template.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ProjectNotFoundMessageTemplateComponent
{
    public data: WritableSignal<ProjectNotFoundMessage>;
    
    constructor() {
        this.data = signal<ProjectNotFoundMessage>(null);
    }
}